<!--
 * @Description: 线上推广详情
 -->
<template>
  <div class="table-box">
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>任务时间：</span>
          <el-select v-model="taskMonth" placeholder="请选择" @change="getList">
            <el-option
              v-for="date in taskMonths"
              :key="date"
              :label="date"
              :value="date"
            />
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button size="mini" type="primary" @click="getList">搜索</el-button>
      </div>
    </div>
    <!--列表-->
    <div>
      <el-table
        :data="taskList"
        border
        style="width: 100%;"
        :max-height="tableMaxHeight"
        :stripe="true"
        :highlight-current-row="false"
        class="v2-base-table"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="50"
          fixed="left"
        ></el-table-column>

        <el-table-column
          v-for="(item, index) in titleList[0]"
          :key="index"
          :show-overflow-tooltip="true"
          align="center"
          :label="item"
          :fixed="index < 2 ? 'left' : false"
        >
          <template slot-scope="{ row }">
            <span>{{ row[index] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { selectMonthTask } from '../../api';

export default {
  name: 'detail-6',
  props: {
    // 任务详情接口返回的是月度集合
    detail: {
      type: Object,
      default() {
        return { uvValues: [] };
      }
    },
    row: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tableMaxHeight: 300,
      taskList: [],
      titleList: [],
      taskMonths: [],
      taskMonth: ''
    };
  },
  watch: {
    detail: {
      immediate: true,
      deep: true,
      handler(v) {
        if (v.uvValues && v.uvValues.length) {
          this.taskMonths = v.uvValues.map(item => item.month);
          this.taskMonth = this.taskMonths[0];
          this.getList();
        }
      }
    }
  },
  methods: {
    getList() {
      if (this.taskMonth) {
        selectMonthTask({ ...this.row, month: this.taskMonth }).then(res => {
          let { taskList, titleList } = res.data.data;
          // const total = [];
          // try {
          //   taskList.forEach(i => {
          //     i.slice(2).forEach((count, index) => {
          //       total[index] = (total[index] || 0) + (+count || 0);
          //     });
          //   });
          //   taskList.push(['合计', '-', ...total]);
          // } catch (error) {
          //   console.warn(error);
          // }
          this.taskList = taskList;
          this.titleList = titleList;
          this.tableMaxHeight = document.body.offsetHeight - 280;
        });
      }
    }
  }
};
</script>
